try {
  const myInterval = setInterval(accessible, 1000);

  function accessible() {
    const el = document.querySelector(".yotpo-dropdown-base");
    if(el) {
      let span = document.createElement("span");
      span.textContent = "Rating Select";
      span.setAttribute("id", "scoreDropdownLabel");
      span.classList.add("visually-hidden");
      el.prepend(span);
    }
    const yotpo = document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab");
    if(yotpo) {
      yotpo.forEach((item) => {
        item.setAttribute("role", "tab");
      });
    }
    const yotposelect = document.querySelector("#scoreDropdownInput");
    if(yotposelect) {
      yotposelect.removeAttribute("aria-expanded");
      stop();
    }
  }
  function stop() {
    clearInterval(myInterval);
  }
}
catch(error) {
  console.log('error');
}